import PropTypes from 'prop-types';
import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const ModuleText = ({
    sidebarTitle,
    text,
    borderBottom,
    borderTop,
    isInModal
}) => {

    return (
        <div className={`${isInModal ? '' : 'text-module-container'} z-10 relative flex flex-wrap max-w-container bg-white ${borderBottom ? 'editorial-white-border-b' : ''} ${borderTop ? 'editorial-white-border-t' : 'editorial-white-spacing-t'}`}>
            {/* Left Sidebar */}
            <div className='w-sidebar'>
                <div className='flex flex-col items-center'>
                    <h2 className='type-style-8 inline-block align-middle rotate-180 writing-mode-vertical-rl'>
                        {sidebarTitle}
                    </h2>
                </div>
            </div>
            {/* Body */}
            <div className='flex-1 layout-negative-margin'>
                <section className={`${isInModal ? '' : 'w-text-module'} layout-item-padding`}>
                    <div
                        className='rich-text'
                        dangerouslySetInnerHTML={{__html: text }}/>
                </section>
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    borderBottom: PropTypes.bool,
    borderTop: PropTypes.bool,
    isInModal: PropTypes.bool,
    sidebarTitle: PropTypes.string,
    text: PropTypes.string.isRequired,
};


ModuleText.propTypes = propTypes;

export default ModuleText;
